/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {LocaleAdapterInterface} from '@/services/language/types';
import {Vue} from 'vue-property-decorator';
import {Validator} from 'vee-validate';

/**
 * Vee-validate locale adapter.
 *
 * @implements LocaleAdapterInterface
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export class VeeValidateAdapter implements LocaleAdapterInterface {
    /**
     * Language setter.
     *
     * @param locale
     */
    public async setLocale(locale: string): Promise<void> {
        // configure vee-validate
        const language: any = await import(`vee-validate/dist/locale/${locale}`).catch(() => {
            return import(`vee-validate/dist/locale/en`);
        });

        Vue.nextTick(() => {
            Validator.localize(locale, language);
        });
    }
}
